module.exports = __webpack_public_path__ + "img/qanda02.467f5e4.webp";